import * as THREE from "three";
import type { ProjectileState } from "@dyson/shared";

const ballGeometry = new THREE.CircleGeometry(0.7, 12);
// Glowing hot iron, bright enough to bloom, so shots read against the dark.
const ballMaterial = new THREE.MeshBasicMaterial({ color: new THREE.Color(0xffb060).multiplyScalar(4), fog: false });

/** Fixed-size instanced pool for cannonballs. */
export class ProjectilePool {
  readonly mesh: THREE.InstancedMesh;
  private readonly matrix = new THREE.Matrix4();

  constructor(capacity: number) {
    this.mesh = new THREE.InstancedMesh(ballGeometry, ballMaterial, capacity);
    this.mesh.name = "cannonballs";
    this.mesh.count = 0;
    this.mesh.frustumCulled = false;
  }

  update(projectiles: ProjectileState[]): void {
    const n = Math.min(projectiles.length, this.mesh.instanceMatrix.count);
    for (let i = 0; i < n; i++) {
      const p = projectiles[i]!;
      this.matrix.makeTranslation(p.position.x, p.position.y, 0.3);
      this.mesh.setMatrixAt(i, this.matrix);
    }
    this.mesh.count = n;
    this.mesh.instanceMatrix.needsUpdate = true;
  }
}
